import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { InstructionsComponent } from '../game/instructions/instructions.component';
import { WalletService } from '@app/@shared/services/wallet.service';
import { TrackingService } from '@app/@shared/services/tracking.service';
import { AnalyticsEventName } from '@app/@shared/models/tracking.model';
import { Credentials, CredentialsService } from '@app/auth/credentials.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  @Input() title = '';

  @Input() showBack = true;
  @Input() showBalance = true;

  @Input() type = '';
  @Input() gameType = '';

  @Output() backClick = new EventEmitter<boolean>();
  @Output() balanceClick = new EventEmitter<boolean>();

  @Input() walletS!: WalletService;
  @Input() isLoading = false;

  @Input() trackingS!: TrackingService;
  private _credentials: Credentials | null = null;
  @Input()
  set credentials(value: Credentials | null) {
    this._credentials = value;
  }
  get credentials(): Credentials | null {
    return this._credentials || this.credentialsService.credentials;
  }
  constructor(private modalCtrl: ModalController, private credentialsService: CredentialsService) {}

  goBack() {
    this.backClick.emit(true);
  }

  goWallet() {
    this.balanceClick.emit(true);
  }

  async openInstructions() {
    // console.log('TYPE: ', this.type);
    //console.log('GAMETYPE: ', this.gameType);

    const modal = await this.modalCtrl.create({
      component: InstructionsComponent,
      componentProps: {
        type: this.type,
        gameType: this.gameType,
      },
    });

    await modal.present();
    this.trackingPageInfo(this.type, this.gameType);
  }

  private logoMap: { [key: string]: string } = {
    chispazo: 'chispazo.svg',
    casino: 'gana-gato.svg',
    'gana-gato': 'gana-gato.svg',
    melate: 'melate-revancha-revanchita.svg',
    sorteo: 'sorteo-especial.svg',
    tris: 'tris.svg',
    'prono-sports': 'prono-sports.svg',
    protouch: 'protouch.svg',
    'progol-media-semana': 'progol-media-semana.svg',
    progol: 'progol-revancha.svg',
  };

  getLogoPath(): string | null {
    if (this.gameType === 'progol') {
      if (this.type === 'media-semana') {
        return `assets/logos/progol-media-semana.svg`;
      } else {
        return `assets/logos/progol-revancha.svg`;
      }
    }
    const logoFileName = this.logoMap[this.gameType];
    return logoFileName ? `assets/logos/${logoFileName}` : null;
  }

  trackingPageInfo(type: string, gameType: string) {
    const page = type ? type : gameType;

    this.trackingS.trackEvent(
      'page_visited',
      {
        page_id: 'Instructions for ' + page,
      },
      false,
      false
    );
  }
}
